import React, { useContext } from 'react';
import "./RestaurantCard.css";
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import { IMG_CDN_URL } from '../../utils/links/link';
import Shimmer from '../../Shimmer/Shimmer';
import {CartState} from '../../../Context';
// import { CartState } from '../../../Context';
import { addItem,removeItem } from '../../utils/store/cartSlice';
import { useDispatch } from 'react-redux';
import CheckOut from '../../../CheckOut/CheckOut';
import star from '../../utils/star.svg'
import { AiFillStar } from "react-icons/ai";


const RestaurantCard = () => {
  
  const {
    state:{cart},
    dispatch,
  } = CartState();
   
  const [restInfo,setRestInfo]=useState({});
   //const [info,setInfo]=CartState();
   //const {handleCart,setHandleCart,setItem,item}=useContext(InCart)
  
   const {id}=useParams();

   //const dispatch =useDispatch();
  //console.log(id)
   useEffect(()=>{
    getRestaurantInfo();
 },[]);
 
  async function getRestaurantInfo(){
    const data=await fetch(`https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=28.7040592&lng=77.10249019999999&restaurantId=${id}&submitAction=ENTER`);
    const json=await data.json();
  
    const menuItemsList = json.data.cards[2]["groupedCard"].cardGroupMap.REGULAR.cards;
    const itemCategory = "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
    const NestedItemCategory = "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory";

    const menu = menuItemsList.map(item => {
      if((item.card.card["@type"] === itemCategory) || (item.card.card["@type"] === NestedItemCategory) ) {
        return item.card.card;
      }
    })

    const modifiedData = {
      info : json.data.cards[0].card.card.info,
      M : menu.filter(value => value !== undefined)
    };
    
    setRestInfo(modifiedData)
    console.log(modifiedData)
    

    
  }
  

 
    return !restInfo ?(
     <Shimmer/>
  ):(
    <div>
        <div className='ImgHeaderBinder'>
            <div className='content'>
            <h1 className='TextHeader'>{restInfo?.info?.name}</h1>
            </div>
            <div className="subTextHeader">
            
            <div className='TextRating'>
            {/* <AiFillStar/> */}
            <h3 className='TextRating'>{restInfo?.info?.avgRating}</h3>
            </div>
            {/* </div> */}
            <h3 className='Amt'>{restInfo?.info?.costForTwoMsg}</h3>
            <h3 className='time'>{restInfo?.info?.sla.slaString}</h3>
            <h3 className='city'>{restInfo?.info?.city}</h3>
            <h3 className='Area'>{restInfo?.info?.areaName}</h3>
            </div>
        
        <img className='foodImg' src={IMG_CDN_URL+restInfo?.info?.cloudinaryImageId}/>
        </div>
        <div>
        <h2 className='MenuHead'>Menu</h2>
        <div className='MenuCard'>
        
        {!restInfo.M?<Shimmer/>: Object.values(restInfo.M).map((idx,ele)=>(
        
        idx.itemCards &&
            Object.values(idx.itemCards).map((i,ele)=>(
                 <div className="Menu" >
                <div>
                <img  className='MenuImg' key={ele.id}  src={IMG_CDN_URL+i.card.info.imageId}/>
                </div>
                <div className='MenuText'>
                <h3 key={ele.id}>{i.card.info.name}</h3>
                {console.log("NAME"+i.card.info.name)}
                {
                  !i.card.info.defaultPrice?<h3 key={ele.id}>PRICE: {(i.card.info.price/100)}</h3>:<h3 key={ele.id}>PRICE: {(i.card.info.defaultPrice/100)}</h3>
                }
                
               
                <button className='CartBtn' key={ele.id} onClick={()=>dispatch({type:"ADD_TO_CART",payload:i.card.info})}>Add To cart</button>
                <button className='CartBtn' key={ele.id} onClick={()=>dispatch({type:"REMOVE_FROM_CART",payload:i.card.info})}>Remove From cart</button>
                </div>
              </div>
            ))
            // <div>ooo</div>

        ))}
        
        </div>
        </div>
        <div className='Check'>
        {
          cart.length===0?null:<CheckOut/>
        }
        </div>
        
    </div>
     //<div>UUU</div>
  )
}

export default RestaurantCard;
